import React from "react";
import { Modal } from "../../../../shared/Modal/Modal";
import { Button } from "../../../../shared/Button/Button";
import { useClearAbandonedEnrollment } from "../hooks/useClearAbandonedEnrollment";
import { CircularProgress } from "../../../../shared/CircularProgress/CircularProgress";
import { uiNotification } from "../../../../services/UINotificationService";

const ClearAbandonedEnrollmentModal = ({ onClose, id, refetch }) => {
  const { mutate, isLoading } = useClearAbandonedEnrollment();
  return (
    <Modal
      isOpen
      onClose={onClose}
      header={<h3>Clear Abandoned Enrollment</h3>}
      headerNoBorder
      footer={
        <div className="flex gap-8 justify-end">
          <Button onClick={onClose} size="small">
            Cancel
          </Button>{" "}
          <Button
            onClick={() =>
              mutate(id, {
                onSuccess: () => {
                  onClose();
                  uiNotification.success(
                    "Abandoned enrollment cleared successfully",
                  );
                  refetch();
                },
                onError: () => {
                  uiNotification.error(
                    "Something went wrong. Please try again later!",
                  );
                },
              })
            }
            size="small"
            isDisabled={isLoading}
            leftAdornment={
              isLoading ? <CircularProgress size="small" color="white" /> : null
            }
          >
            Confirm
          </Button>
        </div>
      }
    >
      <p>Are you sure you want to clear the abandoned enrollment?</p>
    </Modal>
  );
};

export default ClearAbandonedEnrollmentModal;
